import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LangCtx = createContext(null);

const initialLang = () => {
  const saved = localStorage.getItem("aura_lang");
  if (saved && translations[saved]) return saved;
  const nav = (navigator.language || "it").slice(0, 2);
  return translations[nav] ? nav : "it";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);
  useEffect(() => {
    localStorage.setItem("aura_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: translations[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
